import styled from 'styled-components';

import { type TooltipContentProps } from '@radix-ui/react-tooltip';

import { isTruncatedString, truncateString } from '../../utils/truncateString';
import { BaseTooltip } from '../BaseTooltip';

interface ITruncatedTextWithTooltipProps {
  text: string;
  maxLength: number;
  dataCy?: string;
  tooltipContentProps?: Omit<TooltipContentProps, 'children'>;
}

const TruncatedText = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const TruncatedTextWithTooltip = ({
  text,
  maxLength,
  dataCy = 'truncated-text-with-tooltip',
  tooltipContentProps,
}: ITruncatedTextWithTooltipProps): JSX.Element => {
  const truncatedText = truncateString(text, maxLength);
  const isTruncated = isTruncatedString(text, maxLength);

  return (
    <BaseTooltip
      message={text}
      disabled={!isTruncated}
      contentProps={tooltipContentProps}
    >
      <TruncatedText
        data-cy={dataCy}
        aria-label={text}
        className="truncated-text"
      >
        {truncatedText}
      </TruncatedText>
    </BaseTooltip>
  );
};
